import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { ChecTooltip } from 'components/chec'
import { DragItem } from 'components/DragAndDrop'
import { Paragraph } from 'components/patterns'
import { StyledDragHandle } from 'components/DragAndDrop/DragItem/DragItem.style'

export const PartDescription = styled(ChecTooltip)`
  width: 295px;
  cursor: pointer;
`

export const RemovePart = styled(ChecTooltip)`
  cursor: pointer;
  width: 20px;
`

const forcedDragHandleStyles = `

`

const listItemGroupForcedStyles = `

`

export const StyledDragItem = styled(DragItem)((props) => {
  const { forceAlignmentStyles } = props

  return `
    ${stylesIf(forceAlignmentStyles, listItemGroupForcedStyles)}
    
    ${StyledDragHandle} {
      ${stylesIf(forceAlignmentStyles, forcedDragHandleStyles)}
    }
  `
})

export const StyledLocationDetails = styled.span`
  margin-right: 12px;
`

export const StyledParagraphSmall = styled(Paragraph)((props) => {
  const { paragraphColor } = props.theme.color

  return `
    margin-bottom: 3px;
    color: ${paragraphColor};
  `
})

export const LocationDetailsSection = styled.div`
  display: flex;
  margin-left: 74px;
  margin-top: 5px;
  margin-bottom: 10px;
`

export const StyledPartNumberContainer = styled.div`
  width: 100px;
  margin-right: 12px;
`

export const StyledColumnDiv = styled.div`
  width: 155px;
  margin-left: 12px;
`

export const DragItemContainer = styled.div``

export const CapDetailsSection = styled.div`
  display: flex;
  margin-left: 74px;
  margin-bottom: 10px;
`
